import React, { useEffect, useState } from "react";
import { AccountMenu } from "./Component/AccountMenu";
import "../node_modules/video-react/dist/video-react.css";
import "./Component/Asset.css";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import { Typography, Button, Divider, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useUser } from "./Provider/UserProvider";
import { API_DOMAIN_URL } from "./Common";
import aichan from "./images/aichan.png";

const MANUAL_URL =
  "https://hacarowp.azurewebsites.net//wp-content/uploads/2026/03/HacaroManual_WebMyPage.pdf";

const sectionHeaderSx = {
  fontWeight: "bold",
  borderLeft: "4px solid #1976d2",
  pl: 1,
  mb: 1,
  mt: 3,
};

function getThisMonthRange() {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, "0");
  const lastDay = new Date(y, now.getMonth() + 1, 0).getDate();
  return {
    from: `${y}/${m}/01 00:00:00`,
    to: `${y}/${m}/${lastDay} 23:59:59`,
  };
}

export function Home() {
  const navigate = useNavigate();
  const { user } = useUser();

  const [totalMembers, setTotalMembers] = useState(null);
  const [measuredThisMonth, setMeasuredThisMonth] = useState(null);
  const [reportedThisMonth, setReportedThisMonth] = useState(null);
  const [recentReports, setRecentReports] = useState([]);

  const authCheck = () => {
    if (!user || !user.id || user.id == "error") {
      navigate("/SignIn");
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (!authCheck()) return;
    const code = process.env.REACT_APP_API_CODE;

    // 登録メンバー数 → 取得後に今月測定人数も取得
    const now = new Date();
    const period = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, "0")}`;
    fetch(
      API_DOMAIN_URL + `/api/GetOwnedMembers?code=${code}&UserId=${user.id}`
    )
      .then((r) => r.json())
      .then((r) => {
        const members = Array.isArray(r) ? r : [];
        setTotalMembers(members.length);
        if (members.length === 0) { setMeasuredThisMonth(0); return; }
        const userIds = members.map((m) => m.id);
        fetch(API_DOMAIN_URL + `/api/GetMeasurementExistanceInTargetPeriod?code=${code}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ UserIds: userIds, Period: period }),
        })
          .then((r) => r.json())
          .then((r) => setMeasuredThisMonth(r.MeasureUserIds ? r.MeasureUserIds.length : 0))
          .catch(() => setMeasuredThisMonth(0));
      })
      .catch(() => { setTotalMembers(0); setMeasuredThisMonth(0); });

    // 今月のレポートジョブ
    const { from, to } = getThisMonthRange();
    fetch(
      API_DOMAIN_URL +
        `/api/GetReportJobInTargetYearMonth?code=${code}&UserId=${user.id}&From=${encodeURIComponent(from)}&To=${encodeURIComponent(to)}`
    )
      .then((r) => (r.status === 200 ? r.json() : []))
      .then((r) => {
        if (!Array.isArray(r)) { setReportedThisMonth(0); setRecentReports([]); return; }
        // 今月作成済みユニークメンバー数
        const uniqueIds = new Set(r.map((j) => j.Userid));
        setReportedThisMonth(uniqueIds.size);
        // 直近5件（Createdで降順）
        const sorted = [...r].sort((a, b) =>
          b.Created.localeCompare(a.Created)
        );
        setRecentReports(sorted.slice(0, 5));
      })
      .catch(() => { setReportedThisMonth(0); setRecentReports([]); });
  }, [user]);

  return (
    <div className="asset-list-root">
      <AccountMenu />
      <Container component="main" maxWidth="sm">
        <CssBaseline />
        <Box sx={{ mt: 4, mb: 6 }}>
          {/* 挨拶 */}
          <Grid container alignItems="center">
            <Grid item xs>
              <Typography variant="h5" fontWeight="bold">
                {user ? user.NickName || user.UserName : ""}様、ようこそ。
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                測定結果は自動で分析され、評価シートに反映されます。
              </Typography>
            </Grid>
            <Grid item>
              <img src={aichan} alt="aichan" style={{ width: 80 }} />
            </Grid>
          </Grid>

          <Divider sx={{ mt: 3 }} />

          {/* 最近の評価シート作成 */}
          <Typography variant="h6" sx={sectionHeaderSx}>
            最近の評価シート作成
          </Typography>
          {recentReports.length === 0 ? (
            <Typography variant="body2" color="text.secondary">
              今月の作成履歴はありません
            </Typography>
          ) : (
            recentReports.map((r, i) => (
              <Grid container key={i} sx={{ mb: 0.5 }}>
                <Grid item sx={{ width: 110 }}>
                  <Typography variant="body2">{r.Created ? r.Created.slice(0, 10) : ""}</Typography>
                </Grid>
                <Grid item>
                  <Typography variant="body2">{r.NickName}</Typography>
                </Grid>
              </Grid>
            ))
          )}
          <Button
            variant="contained"
            color="success"
            sx={{ mt: 2 }}
            onClick={() => navigate("/Report")}
          >
            評価シートを作成
          </Button>

          <Divider sx={{ mt: 3 }} />

          {/* 全体メンバー状況 */}
          <Typography variant="h6" sx={sectionHeaderSx}>
            全体メンバー状況
          </Typography>
          {[
            { label: "登録メンバー", value: totalMembers, note: "（管理者含まず）" },
            { label: "今月の測定人数", value: measuredThisMonth, note: "（管理者含まず）" },
            { label: "今月評価シート作成", value: reportedThisMonth, note: "" },
          ].map((row, i) => (
            <Grid container key={i} sx={{ mb: 0.5 }}>
              <Grid item sx={{ width: 160 }}>
                <Typography variant="body2">{row.label}</Typography>
              </Grid>
              <Grid item sx={{ width: 60 }}>
                <Typography variant="body2">
                  {row.value !== null ? `${row.value}名` : "読込中..."}
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="caption" color="text.secondary">{row.note}</Typography>
              </Grid>
            </Grid>
          ))}
          <Button
            variant="outlined"
            sx={{ mt: 2 }}
            onClick={() => navigate("/History")}
          >
            利用状況
          </Button>

          <Divider sx={{ mt: 3 }} />

          {/* マニュアル */}
          <Typography variant="h6" sx={sectionHeaderSx}>
            マニュアル
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            Hacaroマイページの基本的な使い方をまとめたマニュアルです。
          </Typography>
          <Button
            variant="outlined"
            href={MANUAL_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            マニュアルを見る（PDF）
          </Button>

          <Divider sx={{ mt: 4 }} />

          {/* フッター */}
          <Box sx={{ mt: 2, textAlign: "center" }}>
            <Typography variant="caption" color="text.secondary">
              {/* Hacaro マイページ v1.1.3 - 2026/05/15 */}
              Hacaro マイページ v1.1.3
            </Typography>
          </Box>
        </Box>
      </Container>
    </div>
  );
}
